<template>
  <div style="overflow-y: hidden; padding-right: 15px; padding-left: 15px">
    <splitpanes class="default-theme" horizontal style="height: 90vh">
      <pane size="85">
        <div class="row" style="height:10%">
          <div class="col">
            <b-button-group
              v-if="
                $store.state.authentication.roles.indexOf(
                  FUEL_TANKS_INFO_EXPORT_ROLE
                ) != -1
              "
            >
              <b-button
                style="font-size: 12px; padding: 5px"
                variant="link"
                @click="showOnMap()"
              >
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="32px"
                  height="32px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 360 360"
                  style="enable-background: new 0 0 360 360"
                  xml:space="preserve"
                >
                  <title>{{ $store.state.localization.data.mainPage.fuelTanks.showOnMap }}</title>
                  <g id="XMLID_1088_">
                    <polygon
                      id="XMLID_1104_"
                      style="fill: #cdcdd0"
                      points="240,50 240,80 330,80 330,186.551 330,218.386 330,280 240,280 240,310 
        360,310 360,50 	"
                    />
                    <rect
                      id="XMLID_1105_"
                      x="120"
                      y="50"
                      style="fill: #ebebec"
                      width="120"
                      height="30"
                    />
                    <polygon
                      id="XMLID_1106_"
                      style="fill: #ebebec"
                      points="151.75,280 120,280 120,310 240,310 240,280 	"
                    />
                    <polygon
                      id="XMLID_1107_"
                      style="fill: #cdcdd0"
                      points="30,280 30,111.836 30,80 120,80 120,50 0,50 0,310 120,310 120,280 	"
                    />
                    <path
                      id="XMLID_1108_"
                      style="fill: #64c37d"
                      d="M135,165c0-5.247,0.907-10.28,2.558-14.963L30,111.836V280h90l27.335-78.899
        C140.337,189.699,135,177.054,135,165z"
                    />
                    <path
                      id="XMLID_1109_"
                      style="fill: #64c37d"
                      d="M180,240c0,0-4.527-4.026-10.707-10.635L151.75,280H240h90v-61.614
        l-107.505-38.182C213.037,210.631,180,240,180,240z"
                    />
                    <path
                      id="XMLID_1110_"
                      style="fill: #99eff2"
                      d="M147.335,201.101L120,280h31.75l17.543-50.635
        C162.695,222.309,154.214,212.308,147.335,201.101z"
                    />
                    <path
                      id="XMLID_1111_"
                      style="fill: #78b9eb"
                      d="M30,80l128.308,45.571C164.742,122.023,172.134,120,180,120
        c18.868,0,35.015,11.618,41.701,28.086L330,186.551V80h-90H120H30z"
                    />
                    <path
                      id="XMLID_1112_"
                      style="fill: #ffda44"
                      d="M158.308,125.571L30,80v31.836l107.558,38.201
        C141.251,139.561,148.706,130.864,158.308,125.571z"
                    />
                    <path
                      id="XMLID_1113_"
                      style="fill: #ffda44"
                      d="M225,165c0,5.01-0.925,10.121-2.505,15.204L330,218.386v-31.835l-108.299-38.464
        C223.822,153.31,225,159.016,225,165z"
                    />
                    <path
                      id="XMLID_1114_"
                      style="fill: #ff5023"
                      d="M137.558,150.037C135.907,154.72,135,159.753,135,165
        c0,12.054,5.337,24.699,12.335,36.101c6.879,11.208,15.36,21.208,21.958,28.265C175.473,235.974,180,240,180,240v-60
        c-8.284,0-15-6.716-15-15s6.716-15,15-15v-30c-7.866,0-15.258,2.023-21.692,5.571C148.706,130.864,141.251,139.561,137.558,150.037
        z"
                    />
                    <path
                      id="XMLID_1115_"
                      style="fill: #bf3c1a"
                      d="M195,165c0,8.284-6.716,15-15,15v60c0,0,33.037-29.369,42.495-59.796
        C224.075,175.121,225,170.01,225,165c0-5.984-1.178-11.69-3.299-16.914C215.015,131.618,198.868,120,180,120v30
        C188.284,150,195,156.716,195,165z"
                    />
                    <circle
                      id="XMLID_1116_"
                      style="fill: #ffffff"
                      cx="180"
                      cy="165"
                      r="15"
                    />
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </b-button>
              <b-button
                style="font-size: 12px; padding: 5px"
                variant="link"
                @click="openFuelTankCardModal()"
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="32px"
                  height="32px"
                  x="0px"
                  y="0px"
                  viewBox="0 0 435 435"
                  style="enable-background: new 0 0 435 435"
                  xml:space="preserve"
                >
                  <title>{{ $store.state.localization.data.mainPage.fuelTanks.openFuelTankCard }}</title>
                  <g>
                    <rect
                      y="167.551"
                      style="fill: #00eed1"
                      width="217.5"
                      height="189.897"
                    />
                    <path
                      style="fill: #00ddc2"
                      d="M217.5,357.449H435V167.551H217.5V357.449z M365,237.449v40H263.521v-40H365z"
                    />
                    <polygon
                      style="fill: #00ccb3"
                      points="217.5,77.551 0,77.551 0,167.551 217.5,167.551 435,167.551 435,77.551 	"
                    />
                    <rect
                      x="263.521"
                      y="237.449"
                      style="fill: #ffffff"
                      width="101.479"
                      height="40"
                    />
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </b-button>
              <b-button
                style="font-size: 12px; padding: 5px"
                variant="link"
                @click="exportTable('xlsx')"
                :disabled="report.data == null"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <defs>
                    <linearGradient
                      id="a"
                      x1="4.494"
                      y1="-2092.086"
                      x2="13.832"
                      y2="-2075.914"
                      gradientTransform="translate(0 2100)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="#18884f" />
                      <stop offset="0.5" stop-color="#117e43" />
                      <stop offset="1" stop-color="#0b6631" />
                    </linearGradient>
                  </defs>
                  <title>{{ $store.state.localization.data.mainPage.reports.exportXlsxReportButton }}</title>
                  <path
                    d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
                    style="fill: #185c37"
                  />
                  <path
                    d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
                    style="fill: #21a366"
                  />
                  <path d="M8.512,9.5H19.581V16H8.512Z" style="fill: #107c41" />
                  <path
                    d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
                    style="opacity: 0.10000000149011612; isolation: isolate"
                  />
                  <path
                    d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
                    style="fill: url(#a)"
                  />
                  <path
                    d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
                    style="fill: #fff"
                  />
                  <path
                    d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z"
                    style="fill: #33c481"
                  />
                  <path d="M19.581,16H30v6.5H19.581Z" style="fill: #107c41" />
                </svg>
              </b-button>
              <b-button
                style="font-size: 12px; padding: 5px"
                variant="link"
                @click="exportTable('pdf')"
                :disabled="report.data == null"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient id="pdfGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
                      <stop offset="0" stop-color="#D32F2F"/>
                      <stop offset="0.5" stop-color="#C62828"/>
                      <stop offset="1" stop-color="#B71C1C"/>
                    </linearGradient>
                  </defs>

                  <!-- Фон документа -->
                  <rect x="2" y="2" width="28" height="28" rx="2" ry="2" fill="url(#pdfGrad)" />

                  <!-- P -->
                  <path
                    d="M7.5 11h3.4c1.9 0 3.1 1 3.1 2.8 0 1.9-1.2 2.9-3.1 2.9H9.1V21H7.5V11Zm1.6 1.6v2.7h1.6c0.9 0 1.5-.5 1.5-1.4 0-.9-.6-1.3-1.5-1.3H9.1Z"
                    fill="#fff"
                  />

                  <!-- D -->
                  <path
                    d="M14.8 11h3.6c2.3 0 3.9 1.5 3.9 4s-1.6 4-3.9 4h-3.6V11Zm1.6 1.6v4.8h1.9c1.4 0 2.3-.9 2.3-2.4s-.9-2.4-2.3-2.4h-1.9Z"
                    fill="#fff"
                  />

                  <!-- F -->
                  <path
                    d="M24.8 11h4.7v1.6h-3.1v2.1h2.7v1.6h-2.7V21h-1.6V11Z"
                    fill="#fff"
                  />
                </svg>

                <!-- <svg
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <defs>
                    <linearGradient
                      id="a"
                      x1="4.494"
                      y1="-1712.086"
                      x2="13.832"
                      y2="-1695.914"
                      gradientTransform="translate(0 1720)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="#2368c4" />
                      <stop offset="0.5" stop-color="#1a5dbe" />
                      <stop offset="1" stop-color="#1146ac" />
                    </linearGradient>
                  </defs>
                  <title>$store.state.localization.data.mainPage.reports.exportWordReportButton</title>
                  <path
                    d="M28.806,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5l11.069,3.25L30,9.5V4.191A1.192,1.192,0,0,0,28.806,3Z"
                    style="fill: #41a5ee"
                  />
                  <path
                    d="M30,9.5H8.512V16l11.069,1.95L30,16Z"
                    style="fill: #2b7cd3"
                  />
                  <path
                    d="M8.512,16v6.5L18.93,23.8,30,22.5V16Z"
                    style="fill: #185abd"
                  />
                  <path
                    d="M9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5H8.512v5.309A1.192,1.192,0,0,0,9.705,29Z"
                    style="fill: #103f91"
                  />
                  <path
                    d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
                    style="opacity: 0.10000000149011612; isolation: isolate"
                  />
                  <path
                    d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
                    style="opacity: 0.20000000298023224; isolation: isolate"
                  />
                  <path
                    d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
                    style="fill: url(#a)"
                  />
                  <path
                    d="M6.9,17.988c.023.184.039.344.046.481h.028c.01-.13.032-.287.065-.47s.062-.338.089-.465l1.255-5.407h1.624l1.3,5.326a7.761,7.761,0,0,1,.162,1h.022a7.6,7.6,0,0,1,.135-.975l1.039-5.358h1.477l-1.824,7.748H10.591L9.354,14.742q-.054-.222-.122-.578t-.084-.52H9.127q-.021.189-.084.561c-.042.249-.075.432-.1.552L7.78,19.871H6.024L4.19,12.127h1.5l1.131,5.418A4.469,4.469,0,0,1,6.9,17.988Z"
                    style="fill: #fff"
                  />
                </svg> -->
              </b-button>
              <b-button
                style="font-size: 12px; padding: 5px"
                variant="link"
                @click="exportTable('xml')"
                :disabled="report.data == null"
                v-bind:title="$store.state.localization.data.mainPage.reports.exportXmlReportButton"
              >
                <svg
                  width="32px"
                  height="32px"
                  viewBox="-4 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.112-.024c-2.803 0-5.074 2.272-5.074 5.074v53.841c0 2.803 2.271 5.074 5.074 5.074h45.774c2.801 0 5.074-2.271 5.074-5.074v-38.606l-18.902-20.309h-31.946z"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    fill="#FC7B24"
                  />
                  <g fill-rule="evenodd" clip-rule="evenodd">
                    <path
                      d="M55.977 20.352v1h-12.799s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z"
                      fill="#FB5C1B"
                    />
                    <path
                      d="M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799l-18.903-20.352z"
                      opacity=".5"
                      fill="#fff"
                    />
                  </g>
                  <path
                    d="M19.371 53.848c-.217 0-.414-.089-.541-.27l-3.727-4.97-3.745 4.97c-.126.181-.323.27-.54.27-.396 0-.721-.306-.721-.72 0-.144.037-.306.145-.432l3.889-5.131-3.619-4.826c-.09-.126-.144-.27-.144-.414 0-.343.288-.721.72-.721.217 0 .433.108.576.288l3.439 4.627 3.439-4.646c.125-.18.324-.27.54-.27.378 0 .737.306.737.721 0 .144-.035.288-.125.414l-3.619 4.808 3.889 5.149c.09.126.127.27.127.415.001.396-.323.738-.72.738zm14.455-.018c-.414 0-.738-.324-.738-.738v-9.254l-4.033 9.759c-.055.143-.2.233-.379.233-.144 0-.287-.09-.342-.234l-4.016-9.759v9.254c0 .414-.324.738-.756.738-.414 0-.738-.324-.738-.738v-10.262c0-.648.559-1.207 1.242-1.207.486 0 .99.288 1.188.756l3.438 8.373 3.457-8.373c.199-.468.686-.756 1.189-.756.684 0 1.242.558 1.242 1.207v10.263c.002.414-.322.738-.754.738zm10.546-.108h-5.456c-.594 0-1.08-.486-1.08-1.081v-10.316c0-.396.324-.721.774-.721.396 0 .72.324.72.721v10.065h5.042c.36 0 .647.288.647.648.001.396-.287.684-.647.684z"
                    fill="#fff"
                  />
                  {{$store.state.localization.data.mainPage.reports.exportXmlReportButton}}
                </svg>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div class="row" style="height: 90%;">
          <div class="col-12" style="height: 100%;">
            <b-table
              class="textMiddle"
              style="height: 100%;"
              small
              hover
              bordered
              show-empty
              responsive
              head-variant="light"
              selectable
              select-mode="single"
              :items="report.data"
              :fields="headers"
              v-bind:emptyText="$store.state.localization.data.common.table.noData"
              @row-clicked="fuelTankClicked"
              :foot-clone="hideSummary"
            >
              <template v-slot:empty="scope">
                <div class="row justify-content-md-center">
                  <h5>{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template v-if="hideSummary" v-slot:foot()="data">
                <span class="text-success">{{ report.summary[data.column] }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </pane>

      <pane size="15">
        <div class="row" style="height: 100%;">
          <div class="col-12" style="height: 100%;">
            <b-table
              class="textMiddle"
              style="height: 100%;"
              small
              hover
              bordered
              show-empty
              responsive
              head-variant="light"
              selectable
              select-mode="single"
              :items="userNotifications"
              :fields="notificationsHeaders"
              v-bind:emptyText="$store.state.localization.data.common.table.noData"
            >
              <template v-if="hideSummary" v-slot:foot()="data">
                <span class="text-success">{{ report.summary[data.column] }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </pane>
    </splitpanes>
    <FuelTankCard ref="fuel-tank-card"></FuelTankCard>
  </div>
</template>

<script>
import FuelTankCard from "../UpdateFuelTank/UpdateFuelTankPage.vue";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import {
  fuelTankService,
  utilsService,
  roleService,
  userService,
  notificationService
} from "../../../services";

export default {
  name: "FuelTanksTable",
  components: {
    FuelTankCard,
    Splitpanes,
    Pane
  },
  props: {
    fuelTanksInfo: Array,
    fuelTanks: Array,
    fuelDepos: Array,
  },
  data() {
    return {
      timeout: 60 * 1000,
      currentSelectedRow: null,
      fuelTankCard: {},
      FUEL_TANKS_INFO_EXPORT_ROLE: roleService.FUEL_TANKS_INFO_EXPORT_ROLE,
      userNotifications: [],
      lastUserNotificationId: 0,
      fuelVolumePrecision: userService.FUEL_VOLUME_PRECISION_DEFAULT
    };
  },
  computed: {
    headers() {
      const headers = [];
      const disabledHeadersByDefault = ["waterVolume", "waterLevel"];

      const displayedColumnsSetting =
        this.$store.state.authentication.userSettings.find((x) => {
          return (
            x.settingName == userService.FUEL_TANKS_TABLE_DISPLAYED_COLUMNS
          );
        });

      headers.push({
            key: "number",
            label: "",
            sortable: false,
            thClass: "textMiddle",
          });

      if (displayedColumnsSetting) {
        const displayedColumns =
          displayedColumnsSetting.settingValue.split(",");

        for (let i = 0; i < displayedColumns.length; i++) {
          headers.push({
            key: displayedColumns[i],
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[displayedColumns[i]],
            sortable: true,
            thClass: "textMiddle",
          });
        }
      } else {
        for (let key in this.$store.state.localization.data.mainPage.fuelTanks
          .tableColumns) {
            if (disabledHeadersByDefault.includes(key)) {
              continue;
            }
          headers.push({
            key: key,
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[key],
            sortable: true,
            thClass: "textMiddle",
          });
        }
      }

      return headers;
    },
    notificationsHeaders() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.notifications
          .tableColumns) {
          headers.push({
            key: key,
            label:
              this.$store.state.localization.data.mainPage.notifications.tableColumns[
                key
              ],
            thClass: "textMiddle",
          });
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
    report() {
      const data = [];

      const summary = {
        fuelVolumeTotal: 0,
        fuelVolume: 0,
        fuelVolumeFree: 0,
        fuelVolumePercent: 0,
        fuelWeight: 0,
        fuelTemperature: 0,
        fuelDensity: 0,
        waterVolume: 0,
        fuelLevel: 0,
        fuelVolume15: 0,
        waterLevel: 0
      };

      if (this.fuelTanksInfo == null || this.fuelTanks == null) {
        return {
          data: data,
          summary: summary,
        };
      }

      let countFuelTanks = 0;

      for (let i = 0; i < this.fuelTanks.length; i++) {
        let row = {
          companyName: this.fuelTanks[i].companyName,
          depoName: this.fuelTanks[i].depoName,
          vehicleId: this.fuelTanks[i].vehicleId,
          fuelTankName: this.fuelTanks[i].fuelTankName,
          fuelType: this.fuelTanks[i].fuelType,
          time: new Date(),
          fuelVolumeTotal: 0,
          fuelVolume: 0,
          fuelVolumeFree: 0,
          fuelVolumePercent: 0,
          fuelWeight: 0,
          fuelTemperature: 0,
          fuelDensity: 0,
          waterVolume: 0,
          fuelLevel: 0,
          fuelVolume15: 0,
          fuelTankId: this.fuelTanks[i].fuelTankId,
          waterLevel: 0
        };

        for (let j = 0; j < this.fuelTanksInfo.length; j++) {
          if (this.fuelTanks[i].vehicleId != this.fuelTanksInfo[j].vehicleId) {
            continue;
          }

          const fuelTankInfo = this.fuelTanksInfo[j].fuelTanks.find((item) => {
            return item.fuelTankId == this.fuelTanks[i].fuelTankId;
          });

          if (!fuelTankInfo) {
            continue;
          }

          row.time = new Date(fuelTankInfo.time * 1000);
          row.fuelVolumeTotal = fuelTankInfo.fuelVolumeTotal;
          row.fuelVolume = fuelTankInfo.fuelVolume;
          row.fuelVolumeFree = fuelTankInfo.fuelVolumeFree;
          row.fuelVolumePercent = fuelTankInfo.fuelVolumePercent;
          row.fuelWeight = fuelTankInfo.fuelWeight;
          row.fuelTemperature = fuelTankInfo.fuelTemperature;
          row.fuelDensity = fuelTankInfo.fuelDensity;
          row.waterVolume = fuelTankInfo.waterVolume;
          row.fuelLevel = fuelTankInfo.fuelLevel;
          row.fuelVolume15 = fuelTankInfo.fuelVolume15;
          row.waterLevel = fuelTankInfo.waterLevel;
          countFuelTanks++;

          break;
        }

        data.push({
          number: i + 1,
          companyName: row.companyName,
          depoName: row.depoName,
          vehicleId: row.vehicleId,
          fuelTankName: row.fuelTankName,
          fuelType: row.fuelType,
          time: utilsService.formatDateTime(row.time, utilsService.DATE_TIME_FORMAT),
          fuelVolumeTotal: utilsService.formatNumber(row.fuelVolumeTotal, this.fuelVolumePrecision),
          fuelVolume: utilsService.formatNumber(row.fuelVolume, this.fuelVolumePrecision),
          fuelVolumeFree: utilsService.formatNumber(row.fuelVolumeFree, this.fuelVolumePrecision),
          fuelVolumePercent: utilsService.formatNumber(
            row.fuelVolumePercent,
            2
          ),
          fuelWeight: utilsService.formatNumber(row.fuelWeight, this.fuelVolumePrecision),
          fuelTemperature: utilsService.formatNumber(row.fuelTemperature, 2),
          fuelDensity: utilsService.formatNumber(row.fuelDensity, 4),
          waterVolume: utilsService.formatNumber(row.waterVolume, this.fuelVolumePrecision ),
          fuelLevel: utilsService.formatNumber(row.fuelLevel / this.fuelTanks[i].fuelLevelFactor, 1),
          fuelVolume15: utilsService.formatNumber(row.fuelVolume15, this.fuelVolumePrecision),
          waterLevel: utilsService.formatNumber(row.waterLevel / this.fuelTanks[i].fuelLevelFactor, 1),
          fuelTankId: row.fuelTankId,
        });

        summary.fuelVolumeTotal += row.fuelVolumeTotal;
        summary.fuelVolume += row.fuelVolume;
        summary.fuelVolumeFree += row.fuelVolumeFree;
        summary.fuelWeight += row.fuelWeight;
        summary.fuelTemperature += row.fuelTemperature;
        summary.fuelDensity += row.fuelDensity;
        summary.fuelVolume15 += row.fuelVolume15;
        summary.waterVolume += row.waterVolume;
      }

      summary.fuelVolumePercent = utilsService.formatNumber(
        (100 * summary.fuelVolume) /
          (summary.fuelVolume + summary.fuelVolumeFree),
        2
      );
      summary.fuelVolumeTotal = utilsService.formatNumber(summary.fuelVolumeTotal, this.fuelVolumePrecision);
      summary.fuelVolume = utilsService.formatNumber(summary.fuelVolume, this.fuelVolumePrecision);
      summary.fuelVolumeFree = utilsService.formatNumber(
        summary.fuelVolumeFree,
        this.fuelVolumePrecision
      );
      summary.fuelWeight = utilsService.formatNumber(summary.fuelWeight, this.fuelVolumePrecision);
      summary.waterVolume = utilsService.formatNumber(summary.waterVolume, this.fuelVolumePrecision);

      summary.fuelTemperature = utilsService.formatNumber(
        summary.fuelTemperature / countFuelTanks,
        2
      );
      summary.fuelDensity = utilsService.formatNumber(
        summary.fuelDensity / countFuelTanks,
        4
      );

      summary.fuelVolume15 = utilsService.formatNumber(summary.fuelVolume15, this.fuelVolumePrecision);

      return {
        data: data,
        summary: summary,
      };
    },
    hideSummary() {
      const hideSummarySetting =
        this.$store.state.authentication.userSettings.find((x) => {
          return (
            x.settingName == userService.FUEL_TANKS_TABLE_HIDE_SUMMARY
          );
        });

      if (hideSummarySetting && hideSummarySetting.settingValue == "true") {
        return false;
      } else { return true; }
    },
  },
  async created() {
    await this.getUserNotifications();

    const fuelVolumePrecisionSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.FUEL_VOLUME_PRECISION;
      });

      if (fuelVolumePrecisionSetting) {
        this.fuelVolumePrecision = parseInt(fuelVolumePrecisionSetting.settingValue);
      } else {
        this.fuelVolumePrecision = userService.FUEL_VOLUME_PRECISION_DEFAULT;
      }
  },
  methods: {
    fuelTankClicked(row) {
      this.currentSelectedRow = row;
    },
    async exportTable(format) {
      const normalizedHeaders = [];

      for (let i = 0; i < this.headers.length; i++) {
        normalizedHeaders.push({
          key: this.headers[i].key,
          label: this.headers[i].label,
        });
      }

      await fuelTankService.exportFuelTanks(
        format,
        normalizedHeaders,
        "fuelTanks",
        this.report.data,
        this.report.summary
      );
    },
    showOnMap() {
      this.$emit("fuelTankClickedEvent", this.currentSelectedRow.vehicleId);
    },
    async openFuelTankCardModal() {
      const response = await fuelTankService.getFuelTankCard(
        this.currentSelectedRow.vehicleId,
        this.currentSelectedRow.fuelTankId
      );

      if (response.isSuccess) {
        this.fuelTankCard = response.data.fuelTankCard;
        this.$refs["fuel-tank-card"].open(this.fuelTankCard, this.fuelDepos);
      }
    },
    async getUserNotifications() {
      const userNotificationsReponse = await notificationService.getUserNotifications(this.lastUserNotificationId);

      if (userNotificationsReponse.isSuccess && userNotificationsReponse.data.userNotifications.length != 0) {
        this.displayUserNotifications(userNotificationsReponse.data.userNotifications);
      }

      setTimeout(this.getUserNotifications.bind(this), this.timeout);
    },
    displayUserNotifications(data) {
      const userNotifications = [];

        for (let i = 0; i < data.length; i++) {
          const notificationData = JSON.parse(data[i].notificationText);

          const template = this.$store.state.localization.data.mainPage.notifications.templates.find(x => x.id == data[i].notificationType);
          if (template) {
            let notificationText = "";

            if (data[i].notificationType == notificationService.FUEL_CONSUMPTION_SENSOR_VERIFICATION) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{verificationDate}", this.formatTime(notificationData.verificationDate));
            } else if (data[i].notificationType == notificationService.FUEL_LEVEL_SENSOR_VERIFICATION) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{verificationDate}", this.formatTime(notificationData.verificationDate));
            } else if (data[i].notificationType == notificationService.MAX_FUEL_HEIGHT) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{maxFuelHeight}", notificationData.maxFuelHeight).replace("{fuelLevel}", notificationData.fuelLevel);
            } else if (data[i].notificationType == notificationService.MIN_FUEL_HEIGHT) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{minFuelHeight}", notificationData.minFuelHeight).replace("{fuelLevel}", notificationData.fuelLevel);
            } else if (data[i].notificationType == notificationService.MAX_WATER_HEIGHT) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{maxWaterHeight}", notificationData.maxWaterHeight).replace("{waterLevel}", notificationData.waterLevel);
            } else if (data[i].notificationType == notificationService.MIN_WATER_HEIGHT) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{minWaterHeight}", notificationData.minWaterHeight).replace("{waterLevel}", notificationData.waterLevel);
            } else if (data[i].notificationType == notificationService.FUEL_LEVEL_CRITICAL || data[i].notificationType == notificationService.FUEL_LEVEL_ALARM) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{fuelLevel}", notificationData.fuelLevel);
            } else if (data[i].notificationType == notificationService.NO_FUEL_DATA) {
              notificationText = template.text.replace("{fuelDepoName}", notificationData.fuelDepoName).replace("{fuelTankName}", notificationData.fuelTankName).replace("{fuelDataLastTime}", this.formatTime(notificationData.fuelDataLastTime));
            }

            userNotifications.push({
              id: data[i].id,
              time: this.formatTime(data[i].time),
              notificationText: notificationText
            });
          }
        }

        for (let i = 0; i < this.userNotifications.length; i++) {
          userNotifications.push(this.userNotifications[i]);
        }
        
        this.userNotifications = userNotifications;
        this.lastUserNotificationId = data[0].id;
      },
      formatTime(time) {
        return utilsService.formatDateTime(new Date(time * 1000), utilsService.DATE_TIME_FORMAT);
      }
  },
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}

.splitpanes.default-theme .splitpanes__pane {
    background-color:#FFFFFF;
}

/* tbody {
  background-color:#FFFFFF;
} */

.b-table-sticky-header, .table-responsive {
  margin-bottom: 0rem !important;
}

.splitpanes--horizontal > .splitpanes__splitter {
  min-height: 20px;
  /* background: linear-gradient(0deg, #ccc, #28a745); */
}

.b-table thead {
  position: sticky;
  top: 0;
}

</style>
